export const HSL_SATURATION_RULES = {
    OVERALL_SATURATION_CONSISTENCY: {
        condition: (globalSaturation, partitionsData) => {
            if (!globalSaturation?.level) return false;

            const partitions = [
                partitionsData?.blacks,
                partitionsData?.shadows,
                partitionsData?.midtones,
                partitionsData?.highlights,
                partitionsData?.whites
            ].filter(Boolean);

            let consistentCount = 0;
            partitions.forEach((partition) => {
                const level = partition?.saturation?.level;
                if (!level) return;
                if (level === globalSaturation.level) consistentCount += 1;
            });

            return consistentCount >= 3;
        }
    },
    OVERALL_SATURATION_VARIATIONS: {
        condition: (globalSaturation, partitionsData) => {
            if (!globalSaturation?.level) return null;

            const partitions = [
                { name: 'blacks', data: partitionsData?.blacks },
                { name: 'shadows', data: partitionsData?.shadows },
                { name: 'midtones', data: partitionsData?.midtones },
                { name: 'highlights', data: partitionsData?.highlights },
                { name: 'whites', data: partitionsData?.whites }
            ].filter(partition => partition.data);

            const variations = partitions
                .filter(partition => {
                    const level = partition.data?.saturation?.level;
                    if (!level) return false;
                    if (level !== 'STRONG' && level !== 'WEAK') return false;
                    return level !== globalSaturation.level;
                })
                .map(partition => ({
                    name: partition.name,
                    level: partition.data.saturation.level
                }));

            return variations.length > 0 ? variations : null;
        }
    },
    SHADOW_HIGHLIGHT_SATURATION_CONTRAST: {
        condition: (_globalSaturation, partitionsData) => {
            const shadowsMean = partitionsData?.shadows?.saturation?.statistics?.mean;
            const highlightsMean = partitionsData?.highlights?.saturation?.statistics?.mean;
            if (shadowsMean == null || highlightsMean == null) return false;
            return highlightsMean - shadowsMean >= 20;
        }
    }
};
